export const WEEKDAY = ['日', '月', '火', '水', '木', '金', '土'];
export const DISABLE_DATE_TIME = '00:00';
export const ZERO_MINUTES = '00';
export const THIRTY_MINUTES = '30';
export const TIMELINE_UNIT = 30;
